import './styles.scss';
import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {IStore} from '../../redux/interface';
import {Link, useParams} from 'react-router-dom';
import {FormattedMessage} from 'react-intl';
import {useGetTranslations} from '../../utils/hooks/useGetTranslations';
import {TranslationKeys} from '../../utils/constants/routeConstants';
import {
  articleAsyncActions, getTeiArticle
} from '../../redux/pageAsyncActions';
import './styles.scss';
import Loader from '../../components/loader';

export const ArticleTableOfContents: React.FunctionComponent = () => {
  const {
    article: {
      article
    },
    status: {
      loading
    }
  } = useSelector((state: IStore) => state);
  const dispatch = useDispatch();
  const {articleId} = useParams();

  useGetTranslations({
    translationKey: TranslationKeys.Article
  });

  useEffect(() => {
    if (articleId) {
      if (!article || article.id.toString() !== articleId) {
        dispatch(articleAsyncActions[getTeiArticle](articleId));
      }
    }
  }, [articleId]);

  return <div className="table-of-contents-page">
    {!article && loading.includes(getTeiArticle) && <Loader className="table-of-contents-page__loader"/>}
    {article && <header className="table-of-contents-page__header">
      <h1><FormattedMessage
        id={'gritx.article.tableOfContents'}
        defaultMessage={'Table Of Contents'}
      /></h1>
      {article && <Link to={`/article/${article.id}`} className="table-of-contents-page__link">
        <FormattedMessage
          id={'gritx.article.backToArticle'}
          defaultMessage={'Back to article'}
        /></Link>}
      {article && <Link to={`/article/sections/${article.id}`} className="table-of-contents-page__link">
        <FormattedMessage
          id={'gritx.article.viewAll'}
          defaultMessage={'View All'}
        /></Link>}
    </header>}
    {article && <main className="table-of-contents-page__container">
      <div className="table-of-contents-page__body">
        {article.sections.map((section, i) => {
          return <div className="table-of-contents-page__body-line" key={i}>
            <Link to={`/article/section/${article.id}/${i}`}
              className="table-of-contents-page__body-link">{section.number} {section.title}</Link>
          </div>;
        })}
      </div>
    </main>}
  </div>;
};
